import $ from 'jquery'

// jQuery 4 removed these helpers. The webpack `jquery` import is not always
// the same object as window.jQuery (Drupal) or window.top.jQuery (production
// external). Patch every one of them so select2 and the console see the methods.
const patch = (jQuery) => {
  if (!jQuery) {
    return
  }

  if (typeof jQuery.isArray !== 'function') {
    jQuery.isArray = Array.isArray
  }

  if (typeof jQuery.isFunction !== 'function') {
    jQuery.isFunction = (value) => typeof value === 'function'
  }

  if (typeof jQuery.parseJSON !== 'function') {
    jQuery.parseJSON = (value) => JSON.parse(value)
  }

  if (typeof jQuery.trim !== 'function') {
    jQuery.trim = (value) => (value == null ? '' : String(value).trim())
  }

  if (typeof jQuery.camelCase !== 'function') {
    jQuery.camelCase = (value) => String(value)
      .replace(/^-ms-/, 'ms-')
      .replace(/-([\da-z])/gi, (_, letter) => letter.toUpperCase())
  }
}

patch($)
patch(window.jQuery)
patch(window.$)

try {
  if (window.top) {
    patch(window.top.jQuery)
    patch(window.top.$)
  }
} catch (e) {
  // Parent window is cross-origin.
}
